import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <p className="p-6 text-slate-500">Загрузка…</p>;
  if (!user) return <Navigate to="/app/login" replace />;
  return <Outlet />;
}
